export function updateProfileRequest(token, data) {
  return {
    type: '@user/UPDATE_PROFILE_REQUEST',
    payload: { token, data },
  };
}

export function updateProfileSuccess(data) {
  return {
    type: '@user/UPDATE_PROFILE_SUCCESS',
    payload: { data },
  };
}

export function updateProfileFailure() {
  return {
    type: '@user/UPDATE_PROFILE_FAILURE',
  };
}

export function changePasswordRequest(token, data) {
  return {
    type: '@user/CHANGE_PASSWORD_REQUEST',
    payload: { token, data },
  };
}

export function changePasswordResponse(token, data) {
  return {
    type: '@user/CHANGE_PASSWORD_RESPONSE',
    payload: { token, data },
  };
}

export function getDataProfileRequest(token) {
  return {
    type: '@user/GET_DATA_PROFILE_REQUEST',
    payload: { token },
  };
}

export function getDataProfileResponse(data) {
  return {
    type: '@user/GET_DATA_PROFILE_RESPONSE',
    payload: { data },
  };
}
